// Selectors
export const searchResultsChannelIdSelector = (state) => state.search.results.params.channelId;
export const searchResultsRegionIdSelector = (state) => state.search.results.params.regionId;
export const searchResultsArrivalDateSelector = (state) => state.search.results.params.arrivalDate;
export const searchResultsDurationSelector = (state) => state.search.results.params.duration;
export const searchResultsPartySelector = (state) => state.search.results.params.party;

export const searchResultsSelector = (state) => state.search.results.results;

export const searchResultsParamsSelector = (state) => state.search.results.params;
export const hasDoneASearchSelector = (state) => {
  const searchResults = searchResultsParamsSelector(state);
  return searchResults && Object.values(searchResults).length > 0;
};
export const searchResultsPendingParamsSelector = (state) => state.search.results.pendingParams;
export const searchResultsSearchIdSelector = (state) => state.search.results.searchId;
